var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "activitytrackermenu right-dropdown dropdown-menu pull-left",
      attrs: { id: "right-filter" },
    },
    [
      _c(
        "ul",
        {
          attrs: { role: "menu" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        _vm._l(_vm.headers, function (cellVal) {
          return _c(
            "li",
            { key: cellVal, staticClass: "col-xs-12 column-name mb-5" },
            [
              _c(
                "div",
                {
                  staticClass: "col-xs-12 p-0",
                  class: {
                    "tooltip-wrapper":
                      _vm.mandatoryColumns &&
                      _vm.mandatoryColumns.includes(cellVal),
                  },
                },
                [
                  _vm.mandatoryColumns && _vm.mandatoryColumns.includes(cellVal)
                    ? _c("span", { staticClass: "tooltiptext" }, [
                        _vm._v("Mandatory column"),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "d-flex" }, [
                    _c("span", { staticClass: "checkbox inline-checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userSelectableColumns,
                              expression: "userSelectableColumns",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled:
                              _vm.mandatoryColumns &&
                              _vm.mandatoryColumns.includes(cellVal),
                          },
                          domProps: {
                            value: cellVal,
                            checked: Array.isArray(_vm.userSelectableColumns)
                              ? _vm._i(_vm.userSelectableColumns, cellVal) > -1
                              : _vm.userSelectableColumns,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.userSelectableColumns,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = cellVal,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.userSelectableColumns = $$a.concat([
                                      $$v,
                                    ]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.userSelectableColumns = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.userSelectableColumns = $$c
                              }
                            },
                          },
                        }),
                        _c("span", { staticClass: "cr" }),
                      ]),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "select-item",
                        class: {
                          "font-bold":
                            _vm.userSelectableColumns.indexOf(cellVal) > -1,
                          "font-normal":
                            _vm.userSelectableColumns.indexOf(cellVal) === -1,
                        },
                      },
                      [_vm._v(_vm._s(_vm._f("capitalize")(cellVal)))]
                    ),
                  ]),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }